import { useConfirmDialogStore } from '@/store';
import { ConfirmDialog } from 'primereact/confirmdialog';

const ConfirmationDialog = () => {
	const { hide, isVisible, message, props } = useConfirmDialogStore((state) => state);
	const ptStyles = props?.pt || {};

	return (
		<ConfirmDialog
			{...(props || {})}
			visible={isVisible}
			onHide={hide}
			message={message}
			draggable={false}
			closable={false}
			pt={{
				...ptStyles,
				root: { className: 'rounded-t-3xl rounded-b-3xl font-poppins text-body-medium text-base w-[30rem]', ...ptStyles?.root },
				content: { className: 'py-0', ...ptStyles?.content },
				message: { className: 'm-0', ...ptStyles?.message },
				header: { className: 'rounded-t-3xl !h-auto !p-6 !pb-4', ...ptStyles?.header },
				footer: { className: 'rounded-b-3xl p-6', ...ptStyles?.footer },
				rejectButton: { className: 'text-white rounded-full !px-6 !py-2 text-lg font-medium font-poppins', ...ptStyles?.rejectButton },
				acceptButton: { className: 'text-white rounded-full !px-6 !py-2 text-lg font-medium font-poppins mr-0', ...ptStyles?.acceptButton },
			}}
		/>
	);
};

export default ConfirmationDialog;
